import { Box, IconButton, Stack, Typography } from '@mui/material';
import { IoClose } from 'react-icons/io5';
import type { ContactCategory } from 'apis/business/agent/contact/types';
import { ContactCategoryIcon } from '@/pages/Business/Setting/Contacts/components/contactCategoryIcons';

type CallLogHeader = {
  id?: number;
  interaction_type?: 'call' | 'chat';
  details?: { session_id?: string };
};

type ContactHeader = {
  phone_number?: string | null;
  category?: ContactCategory;
};

export default function Header({
  callLog,
  contact,
  onClose
}: {
  callLog?: CallLogHeader;

  contact?: ContactHeader;
  onClose: () => void;
}) {
  const getHeaderLabel = () => {
    if (callLog?.interaction_type === 'call') {
      return `Call Recording ${contact?.phone_number ? `(${contact?.phone_number})` : ''}`;
    }
    return `Chat Details ${contact?.phone_number ? `(${contact?.phone_number})` : ''}`;
  };

  return (
    <Box
      sx={{
        px: { xs: 2, lg: 3 },
        py: { xs: 1.5, lg: 2 },
        borderBottom: '1px solid #DEDEDE',
        display: 'flex',
        justifyContent: 'space-between'
      }}
    >
      <Stack direction='row' gap={0.5}>
        {contact?.category === 'vip' && <ContactCategoryIcon category='vip' size={20} showTooltip />}
        <Stack direction='column' alignItems='start'>
          <Typography variant='h6'>{getHeaderLabel()}</Typography>
          {callLog?.details?.session_id && (
            <Typography color='secondary' lineHeight={1.5} fontSize={12}>
              Session ID : {callLog.details.session_id}
            </Typography>
          )}
        </Stack>
      </Stack>
      <IconButton onClick={onClose}>
        <IoClose size={20} />
      </IconButton>
    </Box>
  );
}
